/* eslint-disable */
import React, { Component } from "react";
import {
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Input,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connectModal } from "redux-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { createTeam } from "../../utils/store/actions/teams.actions";
import "react-toastify/dist/ReactToastify.css";
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl as MuiFormControl,
} from "@material-ui/core";

import {getAllProperties} from "../../utils/store/actions/users.actions";


class ModalTeam extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      team: {
        name: "",
        internal: false,
        distributionCountry: "",
      },
      toast: false,
    };
  }
  handleChange = (e: any) => {
    this.setState({
      team: {
        ...this.state.team,
        [e.target.id]:
          e.target.value === "true"
            ? true
            : e.target.value === "false"
            ? false
            : e.target.value,
      },
    });
  };


  handleChangeZone = (event) => {
    this.setState((prevState) => ({
      team: {
        ...prevState.team,
        distributionCountry:  event.target.value,
      },
    }));
  };

  handleCreate = (e: any) => {
    this.setState({ preview: !this.state.preview });
  };

  create = () => {
    this.props.createTeam(this.state.team).then(this.props.handleHide);
  };

  render() {
    const {show, handleHide, t } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    const { team } = this.state;
    const geographicalZoneProperty = this.props.Users?.get_properties?.find(
      (property) => property.key === "GEOGRAPHICAL_ZONE"
    );

    const countries = geographicalZoneProperty?.values ?? [];

    team.distributionCountry = countries.length === 1 ? countries[0] : team.distributionCountry;

    return (
      <div>
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            top: "10vh",
            backgroundColor: "rgb(244, 244, 244)",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            {t("CREATE_TEAM")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            <Grid
              h="100%"
              templateRows="repeat(5, 1fr)"
              templateColumns="repeat(2, 1fr)"
              gap={2}
            >
              <GridItem rowSpan={1} colSpan={1}>
                <FormControl id="name" isRequired>
                  <FormLabel>{t("NAME")}</FormLabel>
                  <Input
                    bg="white"
                    type="text"
                    onChange={(e) => this.handleChange(e)}
                  />
                </FormControl>
              </GridItem>
              <GridItem rowSpan={1} colSpan={2}>
                <FormControl id="internal">
                  <FormLabel>{t("INTERNAL")}</FormLabel>
                  <RadioGroup>
                    <HStack
                      spacing="24px"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <Radio id="internal" value="true">
                        {t("YES")}
                      </Radio>
                      <Radio id="internal" value="false">
                        {t("NO")}
                      </Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>
              </GridItem>
              <GridItem rowSpan={1} colSpan={2}>
                <MuiFormControl fullWidth>
                  <InputLabel id="zones-label">{t('CHOOSE_ZONE')}</InputLabel>
                  <Select
                    labelId="zones-label"
                    id="zones"
                    value={team.distributionCountry}
                    onChange={this.handleChangeZone}>
                    {countries.map((country) => (
                      <MenuItem key={country} value={country}>
                        {country
                          ? this.props.t("ENUMS.COUNTRIES." + country)
                          : ""}
                      </MenuItem>
                    )) }
                  </Select>
                </MuiFormControl>
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            <Button
              style={{ backgroundColor: "#AE0064", color: "#ffff" }}
              onClick={this.create}
              disabled={this.state.team.name === ""}
            >
              {t("DONE")}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  createTeam,
  getAllProperties,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()((connectModal({ name: "team" })(ModalTeam))));
